export default err => {
  const { code, message, next_sms } = err;

  const errors = {
    400: {
      errorPassword: true,
      loading: false,
      message,
    },
    401: {
      errorPassword: true,
      loading: false,
      message,
    },
    404: {
      errorPhone: true,
      loading: false,
      message,
    },
    429: {
      loading: false,
      smsTimer: next_sms,
      getCode: true,
    },
    493: {
      errorSmsAPI: true,
      loading: false,
      getCode: true,
    },
  };

  return errors[code];
};
